<template>
  <div class="content bg">
    <div
        style="font-family: Adobe Heiti Std;font-weight: normal;font-size: 26px;color: #FF7437;position: absolute;top: 24px;left: 54px">
      {{ shijian }}
    </div>
    <div
        style="font-family: PangMenZhengDao;font-weight: 400;font-size: 16px;color: #465683;position: absolute;top: 36px;left: 130px;">
      {{ riqi }}
    </div>
    <div
        style="font-family: Source Han Sans CN;font-weight: 500;font-size: 18px;color: #465683;position: absolute;top: 34px;left: 234px">
      {{ week }}
    </div>
    <img src="../assets/img/new/bt.png" style="width: 1915px;height: 90px;position: absolute;top: 9px;left: 2px;">
    <div class="title">中科汇智大数据管理中心</div>
    <img src="../assets/img/new/logo.png" style="width: 163px;height: 43px;position: absolute;top: 16px;left: 1715px">

    <div class="glow-box">
      <div class="glow-content">
        <el-amap
            style="width: 864px;height: 620px;margin-top: 1px;margin-left: 1px"
            vid="amap"
            :zoom="13"
            :center="mapcenter"
        >
          <el-amap-marker
              v-for="(item,index) in markers"
              :key="index"
              :position="item.position"
              :icon="item.icon"
              :events="item.events"
              :extData="item.data"
          >
          </el-amap-marker>
        </el-amap>
      </div>
    </div>
    <div class="tdqktj">
      <img src="../assets/img/new/tdqktj.png" style="width: 100%;height: 100%">
      <div class="bt" style="position: absolute;top: 6px;left: 65px">投递统计情况</div>
      <div ref="tdtjqk"
           style="width: 100%;height:85%;position: absolute;top: 35px;left: 0"></div>
    </div>
    <div class="qyqktj">
      <img src="../assets/img/new/qyqktj.png" style="width: 100%;height: 100%">
      <div class="bt" style="position: absolute;top: 6px;left: 65px">清运统计情况</div>
      <div ref="qyqktj"
           style="width: 100%;height:85%;position: absolute;top: 35px;left: 0"></div>
    </div>
    <div class="yhzzqk">
      <img src="../assets/img/new/yhzzqk.png" style="width: 100%;height: 100%">
      <div class="bt" style="position: absolute;top: 6px;left: 65px">用户增长情况</div>
      <div ref="yhzzqk" style="width: 100%;height:85%;position: absolute;top: 35px;left: 0;"></div>
    </div>
    <div class="yhtdsdfx">
      <img src="../assets/img/new/yhtdsdfx.png" style="width: 100%;height: 100%">
      <div class="bt" style="position: absolute;top: 6px;left: 65px">用户投递时段分析</div>
      <div ref="yhtdsd" style="width: 100%;height:85%;position: absolute;top: 35px;left: 0;"></div>
    </div>
    <div class="sbtdjl">
      <img src="../assets/img/new/tdjl.png" style="width: 100%;height: 100%;">
      <div class="bt" style="position: absolute;top: 8px;left: 65px">智能设备投递记录</div>
      <div class="liebaok">
        <div
            style="font-family: Source Han Sans CN;font-weight: bold;font-size: 16px;color: #FFFFFF;line-height: 52px;position: absolute;top: 0;left: 0;">
          <img src="../assets/img/new/gzz.png" style="width: 465.4px;height: 42px;">
          <div style="position: absolute;top: -4px;left: 22px">用户编号</div>
          <div style="position: absolute;top: -4px;left: 134px">投递设备</div>
          <div style="position: absolute;top: -4px;left: 249px">投递重量</div>
          <div style="position: absolute;top: -4px;left: 359px">投递时间</div>
        </div>
        <div class="liebaon" id="usertd">
          <div v-for="(item,index) in scrollBoardConfig.data" v-if="index<5" :class="index%2==0?'tiao1':'tiao2'">
            <div class="tiaot" style="position: absolute;top: -4px;left: 22px;width: 63px;text-align: center;">
              {{ item[0] }}
            </div>
            <div class="tiaot"
                 style="position: absolute;top: -4px;left: 94px;width: 130px;text-align: center; white-space: nowrap; overflow: hidden;">
              {{ item[1] }}
            </div>
            <div class="tiaot" style="position: absolute;top: -4px;left: 239px;width: 68px;text-align: center">
              {{ item[2] }}Kg
            </div>
            <div class="tiaot" style="position: absolute;top: -4px;left: 339px;width: 92px;text-align: center">
              {{ item[3] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sbqk">
      <img src="../assets/img/new/sbqk.png" style="width: 100%;height: 100%;">
      <div class="bt" style="position: absolute;top: 8px;left: 65px">设备情况统计</div>
      <div style="position:absolute;top: 60px;">
        <dv-decoration-9
            style="width:80px;height:80px;color: white;position: absolute;left: 45px;font-weight: bold;font-size: 20px;color: #FFFFFF;">
          {{ zx }}%
        </dv-decoration-9>
        <dv-percent-pond :config="sbzxqk" style="width:298px;height:24px;position:absolute;top: 32px;left: 165px;"/>
        <div
            style="font-weight: bold;font-size: 16px;color: #FFFFFF;position: absolute;top: 0px;left: 164px;width: 200px;">
          设备在线情况
        </div>
        <div
            style="font-weight: bold;font-size: 16px;color: #FFFFFF;position: absolute;top: 66px;left: 164px;width: 200px;display: flex">
          在线设备
          <p style="font-weight: bold;font-size: 20px;color: #4BF3F9;margin-left: 20px;line-height: 20px;">
            {{ tjxq.xt - lxru - csru }}</p></div>
        <div
            style="font-weight: bold;font-size: 16px;color: #FFFFFF;position: absolute;top: 66px;left: 324px;width: 200px;display: flex">
          离线设备
          <p style="font-weight: bold;font-size: 20px;color: #4BF3F9;margin-left: 20px;line-height: 20px;">{{
              lxru
            }}</p></div>
      </div>
      <div style="position:absolute;top: 200px;">
        <dv-decoration-9
            style="width:80px;height:80px;color: white;position: absolute;left: 45px;font-weight: bold;font-size: 20px;color: #FFFFFF;">
          {{ my }}%
        </dv-decoration-9>
        <dv-percent-pond :config="sbmyqk" style="width:298px;height:24px;position:absolute;top: 32px;left: 165px;"/>
        <div
            style="font-weight: bold;font-size: 16px;color: #FFFFFF;position: absolute;top: 0px;left: 164px;width: 200px;">
          设备满溢情况
        </div>
        <div
            style="font-weight: bold;font-size: 16px;color: #FFFFFF;position: absolute;top: 66px;left: 164px;width: 200px;display: flex">
          空闲设备
          <p style="font-weight: bold;font-size: 20px;color: #4BF3F9;margin-left: 20px;line-height: 20px;">{{
              zcru
            }}</p></div>
        <div
            style="font-weight: bold;font-size: 16px;color: #FFFFFF;position: absolute;top: 66px;left: 324px;width: 200px;display: flex">
          满溢设备
          <p style="font-weight: bold;font-size: 20px;color: #4BF3F9;margin-left: 20px;line-height: 20px;">{{
              myru
            }}</p></div>
      </div>

    </div>
    <div class="yygk">
      <img src="../assets/img/new/sjgk.png" style="width: 100%;height: 100%">

      <div class="nrk" style="position: absolute;top: 78px;left: 19px">
        <img src="../assets/img/new/dz.png" class="gz">
        <div
            style="font-family: Source Han Sans CN;font-weight: bold;font-size: 22px;color: #FFF1D9;line-height: 38px;position: absolute;top: 158px;left: 50px;">
          投递总量(吨)
        </div>
        <div style="font-family: Source Han Sans CN;font-weight: bold;font-size: 32px;color: #FFFFFF;line-height: 57px;background: linear-gradient(0deg, #D19A37 0%, #FFFFFF 100%);
        -webkit-background-clip: text;-webkit-text-fill-color: transparent;position:absolute;top: 10px;left:40px;width: 140px;text-align: center;">
          {{ tjxq.td }}
        </div>
      </div>
      <div class="nrk" style="position: absolute;top: 78px;left: 226px">
        <img src="../assets/img/new/dz.png" class="gz">
        <div
            style="font-family: Source Han Sans CN;font-weight: bold;font-size: 22px;color: #FFF1D9;line-height: 38px;position: absolute;top: 158px;left: 50px;">
          清运总量(吨)
        </div>
        <div style="font-family: Source Han Sans CN;font-weight: bold;font-size: 32px;color: #FFFFFF;line-height: 57px;background: linear-gradient(0deg, #D19A37 0%, #FFFFFF 100%);
        -webkit-background-clip: text;-webkit-text-fill-color: transparent;position:absolute;top: 10px;left:40px;width: 140px;text-align: center">
          {{ tjxq.qy }}
        </div>
      </div>
      <div class="nrk" style="position: absolute;top: 78px;left: 433px">
        <img src="../assets/img/new/dz.png" class="gz">
        <div
            style="font-family: Source Han Sans CN;font-weight: bold;font-size: 22px;color: #FFF1D9;line-height: 38px;position: absolute;top: 158px;left: 64px;">
          用户数(位)
        </div>
        <div style="font-family: Source Han Sans CN;font-weight: bold;font-size: 32px;color: #FFFFFF;line-height: 57px;background: linear-gradient(0deg, #D19A37 0%, #FFFFFF 100%);
        -webkit-background-clip: text;-webkit-text-fill-color: transparent;position:absolute;top: 10px;left:40px;width: 140px;text-align: center">
          {{ tjxq.yh }}
        </div>
      </div>
      <div class="nrk" style="position: absolute;top: 78px;left: 641px">
        <img src="../assets/img/new/dz.png" class="gz">
        <div
            style="font-family: Source Han Sans CN;font-weight: bold;font-size: 22px;color: #FFF1D9;line-height: 38px;position: absolute;top: 158px;left: 64px;">
          箱体数(台)
        </div>
        <div style="font-family: Source Han Sans CN;font-weight: bold;font-size: 32px;color: #FFFFFF;line-height: 57px;background: linear-gradient(0deg, #D19A37 0%, #FFFFFF 100%);
        -webkit-background-clip: text;-webkit-text-fill-color: transparent;position:absolute;top: 10px;left:40px;width: 140px;text-align: center">
          {{ tjxq.xt -csru}}
        </div>
      </div>
    </div>
    <div class="tanchuan" v-if="xtxq" @click="ictc()">
      <img src="../assets/img/new/xq/top.png" style="position: absolute;top: 0;left: 0;width: 1920px;height: 116px;">
      <div
          style="font-weight: bolder;font-size: 40px;color: #FFFFFF;line-height: 27px;width: 400px;height: 50px;position: absolute;top: 16px;left: 760px;text-align: center;line-height: 50px;">
        {{ markdata.boxName }}
      </div>
      <div style="position:absolute;left: 34px;top: 85.5px;width: 480px;height: 300px">
        <img src="../assets/img/new/xq/hsxxq.png" style="width: 480px;height: 300px;position: absolute;top: 0;left: 0;">
        <div style="font-weight: bold;font-size: 24px;color: #FFFFFF;position: absolute;top: 18px;left: 25px">
          回收箱信息
        </div>
        <div style="position: absolute;top: 72px;left: 14px;">
          <div class="tiao3">
            <p style="margin-left: 10px;width: 100px;">箱体名称</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 280px">{{ markdata.boxName }}</p>
          </div>
          <div class="tiao4">
            <p style="margin-left: 10px;width: 100px;">安装地址</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 280px; white-space: nowrap; overflow: hidden;">
              {{ markdata.addr }}</p>
          </div>
          <div class="tiao3">
            <p style="margin-left: 10px;width: 100px;">安装时间</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 280px">{{
                markdata.installTime
              }}</p>
          </div>
          <div class="tiao4">
            <p style="margin-left: 10px;width: 100px;">清运时间</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 280px">{{ markdata.clearTime }}</p>
          </div>
        </div>
      </div>

      <div style="position:absolute;left: 34px;top: 417.5px;width: 480px;height: 300px">
        <img src="../assets/img/new/xq/tdcsa.png" style="width: 480px;height: 300px;position: absolute;top: 0;left: 0;">
        <div style="font-weight: bold;font-size: 24px;color: #FFFFFF;position: absolute;top: 18px;left: 25px">投递次数
        </div>
        <div style="position: absolute;top: 72px;left: 14px;">
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">今日投递次数</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">{{
                markdata.tdcs.todayCount
              }}</p>
          </div>
          <div class="tiao6">
            <p style="margin-left: 10px;width: 140px;">昨日投递次数</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px; white-space: nowrap; overflow: hidden;">
              {{ markdata.tdcs.yesterdayCount }}</p>
          </div>
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">本月投递次数</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.tdcs.thisMonthCount }}</p>
          </div>
          <div class="tiao6">
            <p style="margin-left: 10px;width: 140px;">上月投递次数</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.tdcs.lastMonthCount }}</p>
          </div>
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">总投递次数</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">{{
                markdata.tdcs.totalCount
              }}</p>
          </div>
        </div>
      </div>

      <div style="position:absolute;left: 34px;top: 750.2px;width: 480px;height: 300px">
        <img src="../assets/img/new/xq/tdcsa.png" style="width: 480px;height: 300px;position: absolute;top: 0;left: 0;">
        <div style="font-weight: bold;font-size: 24px;color: #FFFFFF;position: absolute;top: 18px;left: 25px">投递重量
        </div>
        <div style="position: absolute;top: 72px;left: 14px;">
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">今日投递重量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">{{
                markdata.tdzl.todayWeight
              }}</p>
          </div>
          <div class="tiao6">
            <p style="margin-left: 10px;width: 140px;">昨日投递重量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px; white-space: nowrap; overflow: hidden;">
              {{ markdata.tdzl.yesterdayWeight }}</p>
          </div>
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">本月投递重量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.tdzl.thisMonthWeight }}</p>
          </div>
          <div class="tiao6">
            <p style="margin-left: 10px;width: 140px;">上月投递重量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.tdzl.lastMonthWeight }}</p>
          </div>
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">总投递重量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">{{
                markdata.tdzl.totalWeight
              }}</p>
          </div>
        </div>
      </div>

      <img src="../assets/img/new/xq/zuo.png"
           style="width: 171px;height: 659px;position:absolute;top: 186px;left: 540px;">
      <img src="../assets/img/new/xq/you.png"
           style="width: 171px;height: 659px;position: absolute;left: 1209px;top: 186px;">
      <img src="../assets/img/new/xq/xt.png"
           style="width: 191px;height: 286px;position:absolute;left: 851px;top: 382px">
      <img src="../assets/img/new/xq/dz.png"
           style="width: 557px;height: 419.7px;position: absolute;left: 668px;top: 550.3px;">
      <img src="../assets/img/new/xq/hsxxx.png"
           style="width: 129.5px;height: 57.4px;position:absolute;left: 672.5px;top: 368.6px">
      <div
          style="font-weight: bold;font-size: 16px;color: #FFFFFF;line-height: 16px;position: absolute;left: 731px;top: 387px;">
        回收箱信息
      </div>
      <img src="../assets/img/new/xq/tdcs.png"
           style="width: 129.5px;height: 57.4px;position:absolute;left: 602px;top: 482.4px">
      <div
          style="font-weight: bold;font-size: 16px;color: #FFFFFF;line-height: 16px;position: absolute;left: 660px;top: 501px;">
        投递次数
      </div>
      <img src="../assets/img/new/xq/tdzl.png"
           style="width: 129.5px;height: 57.4px;position:absolute;left: 672.5px;top: 595.9px">
      <div
          style="font-weight: bold;font-size: 16px;color: #FFFFFF;line-height: 16px;position: absolute;left: 730px;top: 615px;">
        投递重量
      </div>
      <img src="../assets/img/new/xq/txtsb.png"
           style="width: 129.5px;height: 57.4px;position:absolute;left: 1079.9px;top: 368.6px">
      <div
          style="font-weight: bold;font-size: 16px;color: #FFFFFF;line-height: 16px;position: absolute;left: 1138px;top: 387px">
        运行天数
      </div>
      <img src="../assets/img/new/xq/qysj.png"
           style="width: 129.5px;height: 57.4px;position:absolute;left:1148px;top: 482.4px">
      <div
          style="font-weight: bold;font-size: 16px;color: #FFFFFF;line-height: 16px;position: absolute;left:1207px;top: 501px;">
        清运数据
      </div>
      <img src="../assets/img/new/xq/yhsjb.png"
           style="width: 129.5px;height: 57.4px;position:absolute;left: 1079.9px;top:595.9px">
      <div
          style="font-weight: bold;font-size: 16px;color: #FFFFFF;line-height: 16px;position: absolute;left: 1138px;top: 615px;">
        用户数据
      </div>

      <div style="position:absolute;left: 1463.6px;top: 85.5px;width: 456.4px;height: 300px">
        <img src="../assets/img/new/xq/yxts.png" style="width: 480px;height: 300px;position: absolute;top: 0;left: 0;">
        <div style="font-weight: bold;font-size: 24px;color: #FFFFFF;position: absolute;top: 18px;left: 25px">运行天数
        </div>
        <img src="../assets/img/new/xq/txtst.png"
             style="width: 197px;height: 197px;position: absolute;left: -6px;top: 58px;">
        <div class="yxtsa">运行天数</div>
        <div class="tiana">{{ markdata.tian }}</div>
        <div class="tianb">天</div>

      </div>

      <div style="position:absolute;left: 1463.6px;top: 417.5px;width: 456.4px;height: 300px">
        <img src="../assets/img/new/xq/tdcsa.png" style="width: 480px;height: 300px;position: absolute;top: 0;left: 0;">
        <div style="font-weight: bold;font-size: 24px;color: #FFFFFF;position: absolute;top: 18px;left: 25px">清运数据
        </div>
        <div style="position: absolute;top: 72px;left: 14px;">
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">今日清运量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.qysj.todayClearance }}</p>
          </div>
          <div class="tiao6">
            <p style="margin-left: 10px;width: 140px;">昨日清运量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px; white-space: nowrap; overflow: hidden;">
              {{ markdata.qysj.yesterdayClearance }}</p>
          </div>
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">本月清运量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.qysj.thisMonthClearance }}</p>
          </div>
          <div class="tiao6">
            <p style="margin-left: 10px;width: 140px;">上月清运量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.qysj.lastMonthClearance }}</p>
          </div>
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">总清运量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.qysj.totalClearance }}</p>
          </div>
        </div>
      </div>

      <div style="position:absolute;left: 1463.6px;top: 750.2px;width: 456.4px;height: 300px">
        <img src="../assets/img/new/xq/tdcsa.png" style="width: 480px;height: 300px;position: absolute;top: 0;left: 0;">
        <div style="font-weight: bold;font-size: 24px;color: #FFFFFF;position: absolute;top: 18px;left: 25px">用户数据
        </div>
        <div style="position: absolute;top: 72px;left: 14px;">
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">今日新增用户</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.user.todayNewUsers }}</p>
          </div>
          <div class="tiao6">
            <p style="margin-left: 10px;width: 140px;">昨日新增用户</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px; white-space: nowrap; overflow: hidden;">
              {{ markdata.user.yesterdayNewUsers }}</p>
          </div>
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">本月投递重量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.user.thisMonthNewUsers }}</p>
          </div>
          <div class="tiao6">
            <p style="margin-left: 10px;width: 140px;">上月新增用户</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">
              {{ markdata.user.lastMonthNewUsers }}</p>
          </div>
          <div class="tiao5">
            <p style="margin-left: 10px;width: 140px;">总用户量</p>
            <p style="margin-left: 10px;text-align: right;padding-right: 20px;width: 240px">{{
                markdata.user.totalUsers
              }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import * as echarts from 'echarts'
import $ from 'jquery';

export default {
  name: 'HomeView',
  components: {},
  data() {
    return {
      xtxq: false,
      bb: 10,
      mapcenter: [116.40, 39.91],
      markers: [],
      rubblist: [],
      shijian: '',
      riqi: '',
      markdata: [],
      week: '',
      jishiqi: null,
      timeRanges: [],
      deliveryCounts: [],
      totalWeights: [],
      deliveryList: [],
      imgList: [],
      // 排名轮播表
      scrollBoardConfig: {},
      jr: 0,
      pr: 0,
      nowDate: '',
      zx: 0,
      my: 0,
      tjxq: {
        td: 0,
        qy: 0,
        yh: 0,
        xt: 0
      },
      company_id: 1,
      sbzxqk: {},
      sbmyqk: {},
      lxru: 0,
      myru: 0,
      zcru: 0,
      csru: 0,
    }
  },
  created() {
    this.company_id = window.location.href.split('/')[3].split('#')[0] ? window.location.href.split('/')[3].split('#')[0] : 1;
    this.nowDate = this.formatDate(new Date())
    this.getData();
  },
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },
    getData() {
      this.getTIme();
      this.gettdxq();
      this.getqyxg();
      this.getzlxq();
      this.getRubList();
      this.getUserList();
      this.getUserTd();
      this.getDeliveryList();

    },
    getTIme() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      let s = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      this.shijian = h + ":" + s
      let _this = this
      setInterval(function () {
        let date = new Date()
        let h1 = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        let s1 = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        _this.shijian = h1 + ":" + s1
      }, 1000)
      this.riqi = y + '.' + m + '.' + d
      switch (date.getDay()) {
        case 1:
          this.week = '星期一'
          break;
        case 2:
          this.week = '星期二'
          break;
        case 3:
          this.week = '星期三'
          break;
        case 4:
          this.week = '星期四'
          break;
        case 5:
          this.week = '星期五'
          break;
        case 6:
          this.week = '星期六'
          break;
        case 7:
          this.week = '星期日'
          break;
      }
    },
    gettdxq() {
      this.$axios({
        method: 'get',
        url: '/api/v1/data/delivery/volume',
        headers: {Accept: '*/*'},
        params: {
          range: '7d',
          company_id: this.company_id
        }
      }).then(res => {
        var dataa = [];
        var datab = [];
        res.data.items.forEach(a => {
          dataa.push(a.period.substring(5, 10))
          datab.push(a.weight)
        })
        var myChart = echarts.init(this.$refs.tdtjqk)
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            formatter: '{b}<br/>{a}: {c}Kg'
          },
          grid: {
            left: '8%',
            right: '8%',
            bottom: '3%',
            top: "15%",
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: dataa,
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: '#ddd'
              }
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12,
              formatter: '{value}'
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#f5f5f5',
                type: 'dashed'
              }
            }
          },
          series: [{
            name: '重量',
            type: 'bar',
            barWidth: '11px',
            showBackground: true,

            data: datab,
            itemStyle: {
              color: function (params) {
                if (params.dataIndex === 0) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 1, color: '#E8A7F0'},
                    {offset: 0, color: '#F567E9'}
                  ])
                }
                if (params.dataIndex === 1) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 1, color: '#B393FF'},
                    {offset: 0, color: '#8656FF'}
                  ])
                }
                if (params.dataIndex === 2) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 1, color: '#89D9FB'},
                    {offset: 0, color: '#39A7F0'}
                  ])
                }
                if (params.dataIndex === 3) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 1, color: '#86F5CE'},
                    {offset: 0, color: '#11D28E'}
                  ])
                }
                if (params.dataIndex === 4) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 1, color: '#D1ED9E'},
                    {offset: 0, color: '#D1ED9E'}
                  ])
                }
                if (params.dataIndex === 5) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 1, color: '#DDC07D'},
                    {offset: 0, color: '#FEB402'}
                  ])
                }
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 1, color: '#E8ABA1'},
                  {offset: 0, color: '#FF4A21'}
                ])
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              fontSize: 12,
              formatter: '{c}Kg'
            }
          }]
        };
        myChart.setOption(option)
      })
    },
    getqyxg() {
      this.$axios({
        method: 'get',
        url: '/api/v1/data/deliveryClear/volume',
        headers: {Accept: '*/*'},
        params: {
          range: '7d',
          company_id: this.company_id
        }
      }).then(res => {
        var dataa = [];
        var datab = [];
        res.data.items.forEach(a => {
          dataa.push(a.period.substring(5, 10))
          datab.push(a.weight)
        })
        var myChart = echarts.init(this.$refs.qyqktj)
        const option = {
          tooltip: {
            trigger: 'axis',
            formatter: '{b}: {c}kg'
          },
          grid: {
            left: '8%',
            right: '8%',
            bottom: '3%',
            top: "15%",
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: dataa,
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            axisTick: {
              show: false
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12,
              formatter: '{value}'
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#f5f5f5',
                type: 'dashed'
              }
            }
          },
          series: [{
            name: '清运重量',
            type: 'line',
            data: datab,
            symbol: 'circle',
            smooth: true,
            symbolSize: 8,
            itemStyle: {
              color: '#EDDA81'
            },
            lineStyle: {
              color: '#EDDA81',
              width: 3
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 1, color: 'rgba(255,232,203,0)'},
                {offset: 0, color: 'rgba(255,252,226,0.53)'}
              ])
            }
          }]
        };
        myChart.setOption(option)
      })
    },
    getzlxq() {
      this.$axios({
        method: 'get',
        url: '/api/v1/data/getOverallStatistics',
        headers: {accept: '*/*'},
        params: {
          company_id: this.company_id
        }
      }).then(res => {
        this.tjxq.yh = res.data.registeredUserCount
        this.tjxq.td = (res.data.totalDeliveryWeight / 1000).toFixed(2)
        this.tjxq.qy = (res.data.totalClearanceWeight / 1000).toFixed(2)
      })
    },
    getRubList() {
      this.lxru = 0, this.myru = 0, this.zcru = 0, this.csru = 0
      let _this = this
      this.$axios({
        method: 'post',
        url: '/api/v1/data/getDeviceInfoByCompany',
        data: {
          "company_id": this.company_id,
          "page": 1,
          "pageSize": 1000
        }, // 适用于 post、put 等请求
        headers: {Accept: 'application/json'},
      }).then(res => {
        this.mapcenter = [parseFloat(res.data.devices[3].boxCoordinates.split(',')[0]), parseFloat(res.data.devices[3].boxCoordinates.split(',')[1])]
        this.tjxq.xt = res.data.devices.length

        res.data.devices.forEach((item, index) => {
          if (item.sn == "000201010144" || item.sn == '000201010001' || item.sn == '000201010002') {
            this.csru++
            return;
          }
          if (item.alarmStatus == "00000001") {
            this.myru++
            this.markers.push(
                {
                  position: [parseFloat(item.boxCoordinates.split(',')[0]), parseFloat(item.boxCoordinates.split(',')[1])],
                  info: item.boxName,
                  icon: require('@/assets/img/new/my.png'),
                  data: item,
                  events: {
                    click: (e) => this.handleMarkerClick(e) // 绑定点击事件
                  }


                }
            )
          }
          else {
            this.zcru++
            this.markers.push(
                {
                  position: [parseFloat(item.boxCoordinates.split(',')[0]), parseFloat(item.boxCoordinates.split(',')[1])],
                  info: item.boxName,
                  icon: require('@/assets/img/new/zc.png'),
                  data: item,
                  events: {
                    click: (e) => _this.handleMarkerClick(e) // 绑定点击事件
                  }
                }
            )
          }

          let time  = new Date().getTime()
          let time1 = new Date(item.lastOnlineTime).getTime()+(6*60*1000)

          if(time>time1){
            console.log(item)
            this.lxru ++
          }
        })


        const usefulWidth = 100

        const pieceLength = [0.25, 0.5, 0.25]
        const pieceGap = 3

        const lineDash = pieceLength
            .map(l => [usefulWidth * l, pieceGap])
            .reduce((all, current) => [...all, ...current], [])
        this.sbzxqk = {
          value: 100,
          colors: ['#01c4f9', '#46E9F7'],
          lineDash,
          formatter: '',
          localGradient: true,
        }
        this.zx = parseInt(((this.tjxq.xt - this.lxru - this.csru) / (this.tjxq.xt - this. csru)* 100).toFixed(0))
        this.sbzxqk = {
          value: this.zx,
          colors: ['#01c4f9', '#46E9F7'],
          lineDash,
          formatter: '',
          localGradient: true,
        }
        this.my = parseInt(this.zcru / this.markers.length * 100)
        this.sbmyqk = {
          value: this.my,
          colors: ['#01c4f9', '#46E9F7'],
          lineDash,
          formatter: '',
          localGradient: true,
        }

      })
    },
    getjiejiari() {
      this.$axios({
        method: 'post',
        url: '/api/v1/data/getHolidayDeliveryComparison',
        data: {
          "start_date": this.nowDate.split("-")[0] + '-01-01',
          "end_date": this.nowDate,
          "company_id": this.company_id,
        }, // 适用于 post、put 等请求
        headers: {Accept: 'application/json'},
      }).then(res => {
        this.jr = [res.data.avgCounts[0], res.data.avgWeights[0], res.data.dayCounts[0], res.data.deliveryCounts[0], res.data.weights[0]];
        this.pr = [res.data.avgCounts[1], res.data.avgWeights[1], res.data.dayCounts[1], res.data.deliveryCounts[1], res.data.weights[1]];
        this.initChart()
      })
    },
    initChart() {
      let data1 = [], data2 = []
      this.jr.forEach(item => {
        data1.push(item.toFixed(2))
      })
      this.pr.forEach(item => {
        data2.push(item.toFixed(2))
      })
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(this.$refs.jjrdb)
      // 指定图表的配置项和数据
      var option = {
        color: '#fbc321',
        legend: {
          top: 'center',
          right: 'right',
          padding: [0, 10, 0, 10],
          textStyle: {
            color: '#FFF',
          },
          itemWidth: 10,
          itemHeight: 7
        },
        xAxis: {
          data: ['平均数量', '平均重量', '样本数', '投递次', '重量'],
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            interval: 0,
            rotate: 40
          },

        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted',
              color: 'rgba(255, 255, 255,0.3)'
            }
          }
        },
        grid: {
          top: '10%',
          right: '10%',
          bottom: '20%',
          left: '0%'
        },
        series: [
          {
            name: "节假日",
            type: 'bar',
            data: data1,
            barWidth: '20%',
            label: {
              show: true,
              position: 'top',
              color: '#FFF'
            },
            itemStyle: {
              borderRadius: [10, 10, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: '#38D458'},
                {offset: 1, color: '#22AB42'}
              ])
            },
          },
          {
            name: "平日",
            type: 'bar',
            data: data2,
            barWidth: '20%',
            label: {
              show: true,
              position: 'top',
              color: '#FFF'

            },
            itemStyle: {
              borderRadius: [10, 10, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: '#ae3311'},
                {offset: 1, color: '#35afed'}
              ])
            },
          }
        ],
        // 配置图标在容器中的位置
      }

      myChart.setOption(option)
    },
    getUserList() {
      this.$axios({
        method: 'post',
        url: '/api/v1/data/getRegisterTrendRequest',
        headers: {Accept: '*/*'},
        data: {
          "period": "day",
          "count": 7,
          company_id: this.company_id
        }
      }).then(res => {
        var dataa = [];
        var datab = [];
        res.data.trend.forEach(a => {
          dataa.push(a.date.substring(5, 10))
          datab.push(a.count)
        })
        var myChart = echarts.init(this.$refs.yhzzqk)
        // 获取颜色渐变函数

        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'shadow'},
            formatter: '{b}: {c}'
          },
          grid: {
            left: '8%',
            right: '8%',
            top: '15%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            axisLine: {show: false},
            axisTick: {show: false},
            splitLine: {
              show: false,
              lineStyle: {color: '#f5f5f5'}
            }, axisLabel: {
              color: '#fff',
              fontSize: 12,
              formatter: '{value}'
            },
          },
          yAxis: {
            type: 'category',
            data: dataa,
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12,
              formatter: '{value}'
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#f5f5f5',
                type: 'dashed'
              }
            }

          },
          series: [
            {
              name: '数值',
              type: 'bar',
              barWidth: 12,  // 设置柱状图宽度为13像素
              data: datab,
              showBackground: true,
              itemStyle: {
                color: function (params) {
                  return new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                    {offset: 0, color: 'rgba(190,204,221,0.3)'},
                    {offset: 1, color: '#90BEF6'}
                  ])
                },
                borderRadius: [0, 6, 6, 0],

              },
              label: {
                show: true,
                position: 'right',
                formatter: '{c}',
                color: '#fff',
                fontSize: 12,
                fontWeight: 'bold'
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowColor: 'rgba(0, 0, 0, 0.3)'
                }
              }
            }
          ]
        };
        myChart.setOption(option)

        // 响应窗口大小变化
        window.addEventListener('resize', function () {
          myChart.resize();
        });
      })


    },
    getUserTd() {
      this.$axios({
        method: 'post',
        url: '/api/v1/data/getDeliveryTimeDistribution',
        data: {
          "start_date": this.nowDate.split("-")[0] + '-01-01',
          "end_date": this.nowDate,
          "company_id": 2,
        }, // 适用于 post、put 等请求
      }).then(res => {
        let data = [], k = null, l = 0;
        res.data.deliveryCounts.forEach((item, index) => {
          if ((index + 1) % 3 == 0) {
            data.push([l, k])
            l++
            k = null
          } else {
            k += item
          }
        })
        var myChart = echarts.init(this.$refs.yhtdsd)
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {type: 'cross'}
          },
          grid: {
            left: '8%',
            right: '8%',
            bottom: '3%',
            top: "15%",
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: ['3:00', '6:00', '9:00', '12:00', '15:00', '18:00', '21:00', '24:00'],
            axisLine: {
              lineStyle: {
                show: false,
                color: '#fff'
              }
            },
            axisTick: {
              alignWithLabel: true,
              lineStyle: {
                color: '#ddd'
              }
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: false,
              lineStyle: {
                color: '#f5f5f5',
                type: 'dashed'
              }
            },
            axisLabel: {
              show: true,
              color: '#fff',
              fontSize: 12
            }
          },
          series: [
            {
              name: '投递次数',
              type: 'pictorialBar',  // 使用象形柱图
              symbol: 'path://M0,10 L10,10 C5.5,4 5.5,1 5,0 C4.5,1 4.5,4 0,10 z', // SVG路径
              symbolSize: ['100%', '100%'], // 宽度高度100%填充
              data: data,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: 'rgb(4,111,244)'},  // 顶部亮色
                  {offset: 1, color: 'rgba(124,174,237,0.47)'}   // 底部暗色
                ]),     // 内部填充色
                borderColor: '#21a5d5', // 边框颜色
                borderWidth: 1,         // 边框宽度
                opacity: 0.8            // 透明度
              },
              // symbolSize: function (data) {
              //   return data[1] ? data[1] * 0.2 : 10; // 根据数值大小调整气泡大小，无数据时默认大小
              // }
            }
          ]
        };
        myChart.setOption(option)
      })
    },
    getDeliveryList() {
      if (this.jishiqi) {
        clearInterval(this.jishiqi)
      }
      this.$axios({
        method: 'get',
        url: '/api/v1/data/getDeliveryRecordsByCompany',
        headers: {Accept: '*/*'},
        params: {
          page: 1,
          company_id: this.company_id,
          page_size: 100
        }
      }).then(res => {
        let data = []
        this.deliveryList = res.data.data
        this.deliveryList.forEach(item => {
          data.unshift([
            item.userId, item.boxName, item.weight, item.startTime.substring(0, 10)
          ])
        })

        this.scrollBoardConfig = {
          data: data,
        }
        let _this = this
        this.jishiqi = setInterval(function () {
          _this.ListLunXun();
        }, 5000)


      })
    },
    ListLunXun() {
      let data = this.scrollBoardConfig.data;
      if (this.bb < data.length) {
        let parentElement = $('#usertd')
        var class2 = parentElement.children().eq(0).attr('class');
        let lastChild = parentElement.children().last()
        lastChild.remove()
        if (class2 == 'tiao2' || class2 == 'tiao2 donghua') {
          parentElement.prepend('<div class="tiao1 donghua">\n' +
              '  <div class="tiaot" style="position: absolute;top: -4px;left: 22px;width: 63px;text-align: center;">\n' +
              data[this.bb][0] +
              '            </div>\n' +
              '            <div class="tiaot" style="position: absolute;top: -4px;left: 94px;width: 130px;text-align: center; white-space: nowrap; overflow: hidden;">\n' +
              data[this.bb][1] +
              '            </div>\n' +
              '            <div class="tiaot" style="position: absolute;top: -4px;left: 239px;width: 68px;text-align: center">\n' +
              data[this.bb][2] + ' Kg' +
              '            </div>\n' +
              '            <div class="tiaot" style="position: absolute;top: -4px;left: 339px;width: 92px;text-align: center">\n' +
              data[this.bb][3] +
              '            </div>' +
              '            </div>'
          )
        } else {
          parentElement.prepend('<div class="tiao2 donghua">\n' +
              '  <div class="tiaot" style="position: absolute;top: -4px;left: 22px;width: 63px;text-align: center;">\n' +
              data[this.bb][0] +
              '            </div>\n' +
              '            <div class="tiaot" style="position: absolute;top: -4px;left: 94px;width: 130px;text-align: center; white-space: nowrap; overflow: hidden;">\n' +
              data[this.bb][1] +
              '            </div>\n' +
              '            <div class="tiaot" style="position: absolute;top: -4px;left: 239px;width: 68px;text-align: center">\n' +
              data[this.bb][2] + ' Kg' +
              '            </div>\n' +
              '            <div class="tiaot" style="position: absolute;top: -4px;left: 339px;width: 92px;text-align: center">\n' +
              data[this.bb][3] +
              '           </div>' +
              '            </div>'
          )
        }
        this.bb++
      } else {
        this.getDeliveryList();

      }
    },
    handleMarkerClick(e) {
      this.markdata = e.target.getExtData();
      this.markdata.info = {
        boxName: '',
        firstUseTime: '',
        installAddress: '',
        installTime: ''
      }
      this.markdata.tdcs = {
        lastMonthCount: 0,
        thisMonthCount: 0,
        todayCount: 0,
        totalCount: 0,
        yesterdayCount: 0
      }
      this.markdata.tdzl = {
        lastMonthWeight: 0,
        thisMonthWeight: 0,
        todayWeight: 0,
        totalWeight: 0,
        yesterdayWeight: 0
      }
      this.markdata.qysj = {
        lastMonthClearance: 0,
        thisMonthClearance: 0,
        todayClearance: 0,
        totalClearance: 0,
        yesterdayClearance: 0
      }
      this.markdata.user = {
        lastMonthNewUsers: 0,
        thisMonthNewUsers: 0,
        todayNewUsers: 0,
        totalUsers: 0,
        yesterdayNewUsers: 0
      }
      this.markdata.tian = parseInt((new Date().getTime() - new Date(this.markdata.installTime).getTime()) / 1000 / 60 / 60 / 24)
      this.$axios({
        method: 'get',
        url: '/api/v1/data/recycleBoxInfo',
        headers: {Accept: '*/*'},
        params: {
          sn: this.markdata.sn
        }
      }).then(res => {
        this.markdata.info = res.data
        this.$forceUpdate()
      })
      this.$axios({
        method: 'get',
        url: '/api/v1/data/deliveryCount',
        headers: {Accept: '*/*'},
        params: {
          sn: this.markdata.sn
        }
      }).then(res => {
        console.log(res.data)
        this.markdata.tdcs = res.data
        this.$forceUpdate()
      })
      this.$axios({
        method: 'get',
        url: '/api/v1/data/deliveryWeight',
        headers: {Accept: '*/*'},
        params: {
          sn: this.markdata.sn
        }
      }).then(res => {
        this.markdata.tdzl = res.data
        this.$forceUpdate()
      })
      this.$axios({
        method: 'get',
        url: '/api/v1/data/clearance',
        headers: {Accept: '*/*'},
        params: {
          sn: this.markdata.sn
        }
      }).then(res => {
        this.markdata.qysj = res.data
        this.$forceUpdate()
      })
      this.$axios({
        method: 'get',
        url: '/api/v1/data/user',
        headers: {Accept: '*/*'},
        params: {
          sn: this.markdata.sn
        }
      }).then(res => {
        this.markdata.user = res.data
        this.$forceUpdate()
      })
      this.xtxq = true
      console.log(this.markdata)

    },
    ictc() {
      this.xtxq = false
      this.markdata = []
    }


  },

}
</script>

<style>
</style>
